import PropTypes from 'prop-types';
import modalConfig from '../Modal/Modal.config';

const componentDetail = {
  label: 'Customer Number Input - Numeric',
  value: 'NumericCustomerNumber',
};

const builderConfig = {
  validation: {
    minLength: {
      type: 'number',
      required: true,
      defaultValue: '5',
    },
    maxLength: {
      type: 'number',
      required: true,
      defaultValue: '18',
    },
  },
  general: {
    label: {
      type: 'string',
      required: true,
      max: { max: 40, message: `Max length is 40` },
    },
    placeholder: {
      type: 'string',
      required: false,
      max: { max: 36, message: `Max length is 36` },
    },
    hint: {
      type: 'string',
      required: false,
      max: { max: 60, message: `Max length is 60` },
    },
    withHelper: {
      type: 'boolean',
      required: false,
    },
  },
  ...modalConfig.builderConfig,
};

const propTypes = {
  label: PropTypes.string.isRequired,
  placeholder: PropTypes.string,
  hint: PropTypes.string,
  withHelper: PropTypes.bool,
  helper: PropTypes.shape({
    title: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired,
    image: PropTypes.string,
  }),
  input: PropTypes.object,
  noPrefix: PropTypes.bool,
  target: PropTypes.string,
  limit: PropTypes.shape({
    min: PropTypes.number,
    max: PropTypes.number,
  }),
};

const defaultProps = {
  label: 'Label',
  placeholder: window.isBizCentral ? 'Placeholder' : '',
  hint: window.isBizCentral ? 'Hint' : '',
  withHelper: false,
  helper: {
    ...modalConfig.defaultProps,
  },
  noPrefix: false,
};

export default { componentDetail, builderConfig, propTypes, defaultProps };
